import { render, staticRenderFns } from "./ListaLeis.vue?vue&type=template&id=3d030428&scoped=true&"
import script from "./listaLeis.ts?vue&type=script&lang=ts&"
export * from "./listaLeis.ts?vue&type=script&lang=ts&"
import style0 from "./ListaLeis.vue?vue&type=style&index=0&id=3d030428&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d030428",
  null
  
)

export default component.exports